import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";

import "./_UiaIconArrowLink.scss";

const UiaIconArrowLinkRight = () => (
  <path
    d="M0.5 7.5H15.5M15.5 7.5L9.2931 1.5M15.5 7.5L9.2931 13.5"
    stroke="black"
    strokeLinecap="square"
  />
);

const UiaIconArrowLinkLeft = () => (
  <path
    d="M16 7L1 7M1 7L7.2069 13M1 7L7.2069 0.999999"
    stroke="#EB0A1E"
    strokeLinecap="square"
  />
);

type UiaIconArrowLinkProps = {
  left?: boolean;
  right?: boolean;
};

const UiaIconArrowLink = ({ right = false, left = false }: UiaIconArrowLinkProps) => {
  const { projectClass } = useUiContext();

  const getClassName = () =>
    classNames(`${projectClass}_UiaIconArrowLink`, { right }, { left });
  const getSvgPath = () => {
    if (left) return <UiaIconArrowLinkLeft />;
    if (right) return <UiaIconArrowLinkRight />;
    return null;
  };

  return (
    <svg
      className={getClassName()}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {getSvgPath()}
    </svg>
  );
};

export default UiaIconArrowLink;
